// Import images/
import RonspotSquareLogo from "../../assets/login/ronspot-square-logo.svg";
import AzureActive from "../../assets/login/options/azure-active.svg";
import GmailActive from "../../assets/login/options/icon-google.svg";
import DuoActive from "../../assets/login/options/icon-duo.svg";
import OneloginActive from "../../assets/login/options/icon-onelogin.svg";
import EmailActive from "../../assets/login/options/icon-mail.svg";
import OktaLogo from "../../assets/login/options/okta-logo.svg";
import SamlActive from "../../assets/login/options/icon-sso.svg";
import UnitedKingdom from "../../assets/images/flags/united-kingdom.svg";
import France from "../../assets/images/flags/france.svg";
import Spain from "../../assets/images/flags/spain.svg";
import Germany from "../../assets/images/flags/germany.svg";
import Netherlands from "../../assets/images/flags/netherlands.svg";
import Italy from "../../assets/images/flags/italy.svg";
import CzechRepublic from "../../assets/images/flags/czech-republic.svg";
import Poland from "../../assets/images/flags/poland.svg";
import Portugal from "../../assets/images/flags/portugal.svg";
import Ireland from "../../assets/images/flags/ireland.svg";
import Close from "../../assets/images/icons/close.svg";
import Deskbooking from "../../assets/images/desk-booking.png";

import filterIcon from "../../assets/images/icons/filterIcon.svg";
import OrangeStar from "../../assets/images/icons/orange-star.svg";
import GreenMap from "../../assets/images/icons/green-map.svg";
import EditSquare from "../../assets/images/icons/edit-square.svg";
import EditEventIcon from "../../assets/images/icons/edit-event.svg";
import EditAllSeriesIcon from "../../assets/images/icons/edit-all-series.svg";
import MapOrange from "../../assets/images/icons/map-orange.svg";
//import TimeIcon from "../../assets/images/icons/time.svg";
import TimeIcon from "../../assets/images/icons/micon-time.svg";
import UserName from "../../assets/images/icons/user-name.svg";
import cancelBooking from "../../assets/images/icons/black-cancel-icon.svg";
import notification from "../../assets/images/icons/notification.svg";
import profileImg from "../../assets/images/profileImg.jpg";
import edit from "../../assets/images/icons/edit.svg";
import logoutwhite from "../../assets/images/icons/logout-white.svg";
import Profile from "../../assets/images/profile.png";
import ProfileLocation from "../../assets/images/icons/profile-location.svg";
import FillStar from "../../assets/images/icons/fill-star.svg";
import GrayStar from "../../assets/images/icons/gray-star.svg";
import BlackClose from "../../assets/images/icons/black-close.svg";
import LoaderFull from "../../assets/images/loading.gif";
import PlusButton from "../../assets/images/icons/white-plus.svg";
import Deleteicon from "../../assets/images/icons/trash.svg";
import ScheduleMeetingicon from "../../assets/images/icons/schedule-meeting.svg";
import Trash from "../../assets/images/icons/trash.svg";
//import ZoneMap from "../../assets/images/icons/zone-map.svg";
import ZoneMap from "../../assets/images/icons/micon-location.svg";
import ErrorMsg from "../../assets/images/icons/error-msg.svg";
import SheildTick from "../../assets/images/icons/sheild-tick.svg";
import Unapproved from "../../assets/images/unapproved.png";
//import GreenCalender from "../../assets/images/icons/green-calender.svg";
import GreenCalender from "../../assets/images/icons/micon-date.svg";
import Time from "../../assets/images/icons/time.svg";
import Meeting from "../../assets/images/meeting.png";
//import UserIcon from "../../assets/images/icons/user-icon.svg";
import UserIcon from "../../assets/images/icons/micon-organizer.svg";
import Participant from "../../assets/images/icons/micon-user.svg";
import GreenPlus from "../../assets/images/icons/green-plus.svg";
import UserInJoinQueue from "../../assets/images/icons/user-in-join-queue.svg";
import UserInQue from "../../assets/images/icons/user-booking.svg";
import Refreshloader from "../../assets/images/icons/refreshloader.gif";
import ParkingBooking from "../../assets/images/parking-booking.png";
import DeskBooking from "../../assets/images/desk-booking.png";
import ModalTag from "../../assets/images/icons/modal-tag.svg";
import PopupMeet from "../../assets/images/popup-meet.png";
import Map from "../../assets/images/icons/map.svg";
import RepeatEventClock from "../../assets/images/icons/micon-time-circle.svg";
import ExclamationCircle from "../../assets/images/icons/exclamation-circle.svg";
import TimeSlotClock from "../../assets/images/icons/time-slot-clock.svg";
import CalendarMenu from "../../assets/images/icons/calendar-menu.svg";
import CheckInIcon from "../../assets/images/icons/checkin-checkout.svg";
import logo from "../../assets/images/logonew.svg";
import Decline from "../../assets/images/icons/decline.svg";
import BackArrow from "../../assets/images/icons/back-arrow.svg";
import GreenRightArrow from "../../assets/images/icons/green-right-arrow.svg";
import Error from "../../assets/images/icons/error.png";

import SuccessIcon from "../../assets/images/icons/success-icon.svg";
import AlertIcon from "../../assets/images/icons/alert-icon.svg";
import ConfirmIcon from "../../assets/images/icons/confirm-icon.png";
import Success from "../../assets/images/icons/success.png";
import Alert from "../../assets/images/icons/alert.png";
import LargeCar from "../../assets/images/icons/large-car.svg";
import RegularCar from "../../assets/images/icons/regular-car.svg";
import CompactCar from "../../assets/images/icons/compact-car.svg";
import Van from "../../assets/images/icons/van.svg";
import Motorbike from "../../assets/images/icons/motorbike.svg";
import Minibus from "../../assets/images/icons/minibus.svg";
import reschedule from "../../assets/images/icons/reschedule.svg";
import GreenParking from "../../assets/images/icons/green-parking.svg";
import GreenDesking from "../../assets/images/icons/green-desking.svg";
import GreenMeetingRoom from "../../assets/images/icons/green-meeting-room.svg";
import RightBlackArrow from "../../assets/images/icons/right-black-arrow.svg";
import RollIconGray from "../../assets/images/icons/Roll-icon-gray.svg";
import NoSpaceError from "../../assets/images/icons/no-space-error.svg";
import BookingCompleted from "../../assets/images/icons/booking-completed.png";
import TooltipIcon from "../../assets/images/icons/TooltipGreen.svg";
import GrayToggle from "../../assets/images/icons/grey-toggle.svg";
import GreenToggle from "../../assets/images/icons/green-toggle.svg";
import InfoIcon from "../../assets/images/icons/white-required-icon.svg";
import ArrowsVerticalExpand from "../../assets/images/icons/ArrowsVerticalExpand.svg";
import ThumbsUp from "../../assets/images/icons/thums_up.svg";
import LogoBig from "../../assets/images/logo-big.svg";
import AllRole from "../../assets/images/icons/role-fa-user-plus.png"
import Vector from "../../assets/images/icons/Vector.svg";
import DownArrow from "../../assets/images/icons/down-arrow.svg";
import Unhappy from "../../assets/images/icons/unhappy.svg";
import BtnBlackTrash from "../../assets/images/icons/btn-black-trash.svg";
import Document from "../../assets/images/icons/document.svg"
import OfficeClose from "../../assets/images/icons/office-close.svg"
import EmailMessage from "../../assets/images/icons/Email_Message.svg"
// Export them all
export const Images = {
  RonspotSquareLogo,
  AzureActive,
  GmailActive,
  DuoActive,
  OneloginActive,
  EmailActive,
  OktaLogo,
  SamlActive,
  UnitedKingdom,
  France,
  Spain,
  Germany,
  Netherlands,
  Italy,
  CzechRepublic,
  Poland,
  Portugal,
  Ireland,
  Close,
  Deskbooking,
  filterIcon,
  OrangeStar,
  GreenMap,
  EditSquare,
  EditEventIcon,
  EditAllSeriesIcon,
  MapOrange,
  TimeIcon,
  UserName,
  cancelBooking,
  notification,
  profileImg,
  edit,
  logoutwhite,
  Profile,
  ProfileLocation,
  FillStar,
  GrayStar,
  BlackClose,
  LoaderFull,
  PlusButton,
  Deleteicon,
  ScheduleMeetingicon,
  Trash,
  ZoneMap,
  ErrorMsg,
  SheildTick,
  Unapproved,
  GreenCalender,
  Time,
  Meeting,
  UserIcon,
  GreenPlus,
  UserInJoinQueue,
  UserInQue,
  Refreshloader,
  ParkingBooking,
  DeskBooking,
  ModalTag,
  PopupMeet,
  Map,
  RepeatEventClock,
  ExclamationCircle,
  TimeSlotClock,
  CalendarMenu,
  CheckInIcon,
  logo,
  Decline,
  BackArrow,
  GreenRightArrow,
  Error,
  SuccessIcon,
  AlertIcon,
  ConfirmIcon,
  Success,
  Alert,
  LargeCar,
  RegularCar,
  CompactCar,
  Motorbike,
  Van,
  Minibus,
  reschedule,
  GreenParking,
  GreenDesking,
  GreenMeetingRoom,
  RightBlackArrow,
  RollIconGray,
  NoSpaceError,
  BookingCompleted,
  TooltipIcon,
  GrayToggle,
  GreenToggle,
  InfoIcon,
  ArrowsVerticalExpand,
  ThumbsUp,
  LogoBig,
  AllRole,
  Participant,
  Vector,
  DownArrow,
  Unhappy,
  BtnBlackTrash,
  Document,
  OfficeClose,
  EmailMessage
};
